import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MethodLogin = styled.div`
  width: 100%;
  max-width: 380px;
`;

export const LoginForm = styled.div`
  padding: 24px 32px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const FormField = styled.div`
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
  }
`;

export const InputWrapper = styled.div`
  position: relative;

  .ant-input-affix-wrapper {
    padding: 10px 14px;
    border-radius: 8px;

    &:hover, &:focus {
      border-color: #1890ff;
    }
  }

  .ant-input {
    font-size: 14px;
  }
`;

export const AnotherAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;
`;

export const ForgotPassword = styled.span`
  color: #999;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: underline;

  &:hover {
    color: #666;
  }
`;

export const AuthAction = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ButtonLogin = styled.button`
  width: 100%;
  height: 44px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #40a9ff;
  }

  &:disabled {
    background-color: #d9d9d9;
    cursor: not-allowed;
  }
`;

export const RegisterPrompt = styled.div`
  text-align: center;
  font-size: 14px;
  color: #666;

  span {
    color: #999;
    cursor: pointer;
    font-weight: 500;
    text-decoration: underline;

    &:hover {
      color: #666;
    }
  }
`;

export const ErrorMessage = styled.p`
  color: #ff4d4f;
  font-size: 12px;
  margin: 4px 0 0 0;
`;
